export const getToken = (price, country, currency, success = () => {}) => {
  console.log('stripe price-------', price, country, currency)
  return new Promise((resolve, reject) => {
    if (window.stripe) {
      const paymentRequest = window.stripe.paymentRequest({
        country: country, // process.env.VUE_APP_COUNTRY,
        currency: currency, // process.env.VUE_APP_CURRENCY,
        total: {
          label: process.env.VUE_APP_NAME,
          amount: price * 100
        },
        requestPayerName: false,
        requestShipping: false,
        requestPayerEmail: false
      })
      // Check the availability of the Payment Request API first.
      paymentRequest.canMakePayment().then((result) => {
        console.log('stripepay result', result, paymentRequest)
        if (result) {
          resolve(paymentRequest)
        } else {
          reject(new Error('Apple Pay / Google Pay is not available on this device'))
        }
      }).catch(error => {
        reject(error)
      })
      paymentRequest.on('token', (ev) => {
        console.log('tokentoken', ev.token.id)
        success(ev.token.id, ev)
      })
    } else {
      reject(new Error('Payment is still loading — please try again'))
    }
  })
}
